import { useState, useEffect } from "react";

const VisionSection = () => {
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [count3, setCount3] = useState(0);
  const [count4, setCount4] = useState(0);

  useEffect(() => {
    const animateCount = (setter, finalValue) => {
      let start = 0;
      const duration = 2000; // 2 seconds
      const stepTime = Math.abs(Math.floor(duration / finalValue));

      const timer = setInterval(() => {
        start += 1;
        setter(start);
        if (start >= finalValue) {
          clearInterval(timer);
        }
      }, stepTime);
    };

    animateCount(setCount1, 100);
    animateCount(setCount2, 150);
    animateCount(setCount3, 12);
    animateCount(setCount4, 3);
  }, []);

  return (
    <section className="py-4 py-md-5">
      <div className="container px-3 px-md-0">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-5 col-md-6 col-12 align-self-center">
            <h5>Our Vision</h5>
            <h4 className="mb-20 text-dark fw-semibold">Simplifying complex businesses</h4>
            <p className="mb-20">
              Design isn't simply aesthetics. It's giving form to ideas, translating complex thoughts into visual clarity
              that moves hearts and minds. It's thinking, made visible.
            </p>
            <div className="mt-20 mb-20">
              <a
                href="https://api.whatsapp.com/send?phone=+918849858625&amp;text=Hi+Liontouch+Webpark,+I+want+some+more+information+about+your+services.+Please+reply+soon."
                target="_blank"
                rel="noreferrer"
                className="btn-main"
              >
                <div className="d-flex align-items-center">
                  <i className="lni lni-whatsapp me-2"></i>Chat on WhatsApp
                </div>
              </a>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <div className="row">
              <div className="col-md-6 col-6 mb-4 text-center">
                <h4 className="h2 font-weight-normal mb-3">
                  <span className="d-inline-block">{count1}+</span>
                </h4>
                <p className="font-weight-normal">Web Designing</p>
              </div>
              <div className="col-md-6 col-6 mb-4 text-center">
                <h4 className="h2 font-weight-normal mb-3">
                  <span className="d-inline-block">{count2}+</span>
                </h4>
                <p className="font-weight-normal">Product Delivered</p>
              </div>
              <div className="col-md-6 col-6 mb-4 text-center">
                <h4 className="h2 font-weight-normal mb-3">
                  <span className="d-inline-block">{count3}+</span>
                </h4>
                <p className="font-weight-normal">Mobile Applications</p>
              </div>
              <div className="col-md-6 col-6 mb-4 text-center">
                <h4 className="h2 font-weight-normal mb-3">
                  <span className="d-inline-block">{count4}+</span>
                </h4>
                <p className="font-weight-normal">Years of Experience</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
